<template>
  <div class="mb-3">
    <div v-for="input in input_group.text_inputs" :key="input.name">
      <b-form-group>
        <label :for="input.name">{{ labelize(input.name) }}</label>
        <b-form-input type="text" :id="input.name" v-model="form[input.name]"></b-form-input>
      </b-form-group>
    </div>
    <div v-for="input in input_group.select_inputs" :key="input.name">
      <b-form-group :label="labelize(input.name)" :label-for="input.name + '-select'">
        <b-form-select
          :id="input.name + '-select'"
          value="Seleccione..."
          :options="input.options"
          v-model="form[input.name]"
        >
        </b-form-select>
      </b-form-group>
    </div>
    <div v-for="input in input_group.number_inputs" :key="input.name">
      <b-form-group>
        <label :for="input.name">{{ labelize(input.name) }}</label>
        <b-form-input type="number" :id="input.name" v-model="form[input.name]"></b-form-input>
      </b-form-group>
    </div>
    <div v-for="input in input_group.datetime_inputs" :key="input.name">
      <b-form-group>
        <label :for="input.name">{{ labelize(input.name) }}</label>
        <datetime
          type="datetime"
          v-model="form[input.name]"
          :minute-step="10"
          auto
          input-class="form-control"
          class="packapp-theme"
        >
        </datetime>
      </b-form-group>
    </div>
    <div v-for="input in input_group.date_inputs" :key="input.name">
      <b-form-group>
        <label :for="input.name">{{ labelize(input.name) }}</label>
        <b-form-input type="date" :id="input.name" v-model="form[input.name]"></b-form-input>
      </b-form-group>
    </div>
    <div class="mt-2" v-for="input in input_group.boolean_inputs" :key="input.name">
      <b-form-checkbox
        :id="input.name + 'checkbox'"
        v-model="form[input.name]"
        :name="input.name"
        :value="input.true_value"
        :unchecked-value="input.false_value"
      >
        {{ labelize(input.name) }}
      </b-form-checkbox>
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomFields",
  props: {
    form: Object,
    input_group: {
      type: Object,
      default() {
        return {
          text_inputs: [],
          select_inputs: [],
          number_inputs: [],
          datetime_inputs: [],
          boolean_inputs: [],
          date_inputs: []
        };
      }
    }
  },
  beforeMount() {
    this.input_group.text_inputs.forEach((e) => this.$set(this.form, e.name, null));
    this.input_group.select_inputs.forEach((e) => this.$set(this.form, e.name, null));
    this.input_group.number_inputs.forEach((e) => this.$set(this.form, e.name, null));
    this.input_group.datetime_inputs.forEach((e) => this.$set(this.form, e.name, null));
    this.input_group.boolean_inputs.forEach((e) => this.$set(this.form, e.name, e.false_value));
    this.input_group.date_inputs.forEach((e) => this.$set(this.form, e.name, null));
  },
  methods: {
    labelize(str) {
      return str.replace(/_/g, " ").replace(/(^\w|\s\w)/g, (m) => m.toUpperCase());
    }
  }
};
</script>

<style>
.packapp-theme .vdatetime-popup__header,
.packapp-theme .vdatetime-calendar__month__day--selected > span > span,
.packapp-theme .vdatetime-calendar__month__day--selected:hover > span > span {
  background: #20a8d8;
}

.packapp-theme .vdatetime-year-picker__item--selected,
.packapp-theme .vdatetime-time-picker__item--selected,
.packapp-theme .vdatetime-popup__actions__button {
  color: #20a8d8;
}
</style>
